import { Sparkles } from "lucide-react";
import { useMatches } from "../matching/useMatches";
import { MatchAlert, ScoreBadge } from "../matching/MatchAlert";
import { inr } from "../landing/usePricing";

const JobCard = ({ m }) => {
  const l = m.listing;
  return (
    <article data-testid={`worker-match-${m.id}`} className={`border bg-[#0F172A] p-5 ${m.tier === "top" ? "border-orange-500/70" : "border-white/10"}`}>
      <div className="flex items-center justify-between gap-2">
        <ScoreBadge score={m.score} testId={`worker-match-score-${m.id}`} />
        {m.new && <span className="font-mono text-[10px] uppercase text-emerald-300">New</span>}
      </div>
      <p className="mt-3 font-semibold text-white">{l.job_role}</p>
      <p className="text-sm text-slate-400">{l.company_name}</p>
      <p className="text-sm text-slate-500">{l.district}, {l.state} · {l.headcount} openings</p>
      <p className="mt-2 font-mono text-sm text-orange-300">{inr(l.pay_amount)} / {l.pay_type === "daily" ? "day" : "month"}</p>
      {l.facilities.length > 0 && <p className="mt-2 text-xs text-slate-400">{l.facilities.map((f) => f.replace("_", " / ")).join(" · ")}</p>}
    </article>
  );
};

export const WorkerJobs = () => {
  const { data, alertOpen, markSeen } = useMatches("/worker/matches");
  if (!data) return null;
  const top = data.items.filter((m) => m.tier === "top");
  const rest = data.items.filter((m) => m.tier !== "top");
  return (
    <section data-testid="worker-matches" className="space-y-4">
      <MatchAlert open={alertOpen} count={data.new_count} onView={markSeen}
        lines={data.items.filter((m) => m.new).map((m) => ({ id: m.id, score: m.score, text: `${m.listing.job_role} · ${m.listing.district}` }))} />
      <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-white"><Sparkles className="h-5 w-5 text-orange-400" />Instant Job Matches</h2>
      {data.items.length === 0 && <p data-testid="worker-matches-empty" className="text-slate-500">No matching jobs yet. We'll show them here as soon as an employer posts one.</p>}
      {[["Top Match · 80%+", top, "worker-matches-top"], ["Shortlisted · 60-79%", rest, "worker-matches-shortlist"]].map(([t, list, id]) => list.length > 0 && (
        <div key={id} data-testid={id} className="space-y-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">{t} ({list.length})</p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{list.map((m) => <JobCard key={m.id} m={m} />)}</div>
        </div>
      ))}
      <p className="text-xs text-slate-500">Employers contact you through Balangir Group. Never pay anyone to get a job.</p>
    </section>
  );
};
